import React, { useState } from 'react';
import Login from './components/Login';
import Main from './components/Main';

const API_URL = "https://api.epichealth.epicdevagency.com";

function App() {
    const [token, setToken]       = useState(null);
    const [medecin, setMedecin]   = useState(null);

    if (!token) {
        return <Login API_URL={API_URL} onLogin={(t, m) => { setToken(t); setMedecin(m); }} />;
    }

    return <Main API_URL={API_URL} token={token} medecin={medecin} onLogout={() => { setToken(null); setMedecin(null); }} />;
}

export default App;